import React from "react";

import PriceFormatter from "@components/Formatters/PriceFormatter";

import { cn } from "./utils";

type PriceFooterProps = React.HTMLAttributes<HTMLDivElement> & {
  action: React.ReactNode;
  customCurrency?: string;
  price?: number | string | null;
  priceLabel?: React.ReactNode;
  pricePrefix?: React.ReactNode;
  totalLabel?: React.ReactNode;
  totalPrice?: number | string | null;
};

const hasValue = (value: PriceFooterProps["price"]) =>
  value !== null && value !== undefined && value !== "";

export function PriceFooter({
  action,
  className,
  customCurrency,
  price,
  priceLabel,
  pricePrefix,
  totalLabel,
  totalPrice,
  ...props
}: PriceFooterProps) {
  const showPrice = hasValue(price);
  const showTotalPrice = hasValue(totalPrice);

  return (
    <div className={cn("promo-price-footer", className)} {...props}>
      <div className="promo-price-footer__price">
        {showPrice && (
          <>
            {priceLabel && (
              <div className="promo-price-footer__label">{priceLabel}</div>
            )}
            <div className="promo-price-footer__amount">
              {pricePrefix && (
                <span className="promo-price-footer__prefix">
                  {pricePrefix}{" "}
                </span>
              )}
              <PriceFormatter
                price={price as number | string}
                customCurrency={customCurrency}
              />
            </div>
          </>
        )}
        {showTotalPrice && (
          <div className="promo-price-footer__total">
            {totalLabel && (
              <span className="promo-price-footer__total-label">
                {totalLabel}{" "}
              </span>
            )}
            <PriceFormatter
              price={totalPrice as number | string}
              customCurrency={customCurrency}
            />
          </div>
        )}
      </div>
      <div className="promo-price-footer__action">{action}</div>
    </div>
  );
}
